import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export const defaultLocale = "en";
export const locales = ["en", "es"];
export const localePrefix = "as-needed";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix,
});

export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);
